
import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import { loggerMiddleware } from "./loggerMiddleware"

import profileSlice from './slices/profileSlice';
import turfSlice from './slices/turfSlice';
import globalSlice from './slices/global.Slice';
import paymentSlice from './slices/paymentSlice';
import monetisationSlice from './slices/monetisationSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    profile: profileSlice,
    turf: turfSlice,
    globalstate:globalSlice,
    payment:paymentSlice,
    monetisation: monetisationSlice
  },
  devTools: import.meta.env.VITE_API_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
      .concat(loggerMiddleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
